import { render, staticRenderFns } from "./FiltersForTaskIssues.vue?vue&type=template&id=1d5f532a&scoped=true"
import script from "./FiltersForTaskIssues.vue?vue&type=script&lang=js"
export * from "./FiltersForTaskIssues.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./FiltersForTaskIssues.vue?vue&type=style&index=1&id=1d5f532a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f532a",
  null
  
)

export default component.exports